/*var elem = document.querySelector('.menuListProducts');
var flkty = new Flickity(elem, {
  cellAlign: 'center',
  contain: true,
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false
});
*/
document.addEventListener("DOMContentLoaded", function () {
  const heading = document.querySelector(".pair-it-heading");
  const menuListProducts = document.querySelector(".menuListProducts");
  const drawer = document.querySelector(".drawer");

  function updateVisibility() {
    if (!drawer) return;
    const active = drawer.classList.contains("active");
    if (heading) { heading.style.opacity = active ? "1" : "0"; heading.style.visibility = active ? "visible" : "hidden"; }
    if (menuListProducts) { menuListProducts.style.opacity = active ? "1" : "0"; menuListProducts.style.visibility = active ? "visible" : "hidden"; }
  }

  updateVisibility();

  if (drawer) {
    const observer = new MutationObserver(updateVisibility);
    observer.observe(drawer, { attributes: true });
  }

  const cartIconBubble = document.getElementById("cart-icon-bubble");
  if (cartIconBubble) cartIconBubble.addEventListener("click", updateVisibility);

  class CartDrawerCarousel extends HTMLElement {
    constructor() {
      super();
      this.listproducts = this.querySelector('.menuListProducts');
      let flkty = new Flickity(this.listproducts, {
        // Opciones de Flickity
        cellAlign: 'center',
        contain: true,
        wrapAround: true, // Hace que el carrusel sea infinito
        prevNextButtons: false,
        pageDots: false
      });
      if (this.listproducts.classList.contains("cartnoempty")) {
        this.listproducts.style.opacity = "1";
        this.listproducts.style.visibility = "visible";
      }
    }
  }
  customElements.define('cart-drawer-carousel', CartDrawerCarousel);
});



